module.exports = __webpack_public_path__ + "static/img/map.bab2b509.png";